<app-shared-navbar
    [showMenu]="showMenu"
    (showMenuChange)="onShowMenuChange($event)"
    [gradient]="true"
></app-shared-navbar>
